var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkOut = function SvgLinkOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.75c0 .416.334.75.75.75h3.19L8.47 10.47a.75.75 0 0 0 1.06 1.06l6.968-6.97.003 3.19c0 .416.334.75.75.75s.75-.334.75-.75v-5a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0-.75.75M4.25 3A2.25 2.25 0 0 0 2 5.25v10.5A2.25 2.25 0 0 0 4.25 18h10.5A2.25 2.25 0 0 0 17 15.75v-4a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v4c0 .416-.334.75-.75.75H4.25a.75.75 0 0 1-.75-.75V5.25c0-.415.334-.75.75-.75h4c.416 0 .75-.334.75-.75A.75.75 0 0 0 8.25 3z"
  })));
};
export default SvgLinkOut;